/* istanbul ignore file */
import { DropdownMenu } from 'framework/ui/menu';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import OneStopDescriptionToggler from 'domain/gpo/oneStop/List/Settings/OneStopDescriptionToggler';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';

const OneStopSettings = () => {
  return (
    <DropdownMenu
      popupId="onestop-settings"
      iconButton={
        <IconButton className="dropdown-toggle">
          <SettingsIcon />
        </IconButton>
      }
    >
      <OneStopDescriptionToggler />
    </DropdownMenu>
  );
};

export default OneStopSettings;
